import * as Dtos from "../dtos/Tmd.dtos";
import {  IFormFilter } from "../reducers/index";

export const
    LoadGroupItemTemplateCategory: IGroupItemTemplateCategoryLoadActionCreator = () => {
        return {
            type: ACTION_GROUPITEMTEMPLATECATEGORY_LOAD
        }
    },
    LoadGroupItemTemplateCategoryById: IGroupItemTemplateCategoryLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IGroupItemTemplateCategoryLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IGroupItemTemplateCategoryLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveGroupItemTemplateCategory: IGroupItemTemplateCategorySaveActionCreator = (formData) => {
        return {
            type: ACTION_GROUPITEMTEMPLATECATEGORY_SAVE,
            formData
        }
    },
    SaveSuccess: IGroupItemTemplateCategorySaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_GROUPITEMTEMPLATECATEGORY_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IGroupItemTemplateCategorySaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPITEMTEMPLATECATEGORY_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateGroupItemTemplateCategory: IGroupItemTemplateCategoryCreateActionCreator = () => {

        return {
            type: ACTION_GROUPITEMTEMPLATECATEGORY_CREATE
        }
    },
    CreateSuccess: IGroupItemTemplateCategoryCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_GROUPITEMTEMPLATECATEGORY_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IGroupItemTemplateCategoryCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPITEMTEMPLATECATEGORY_CREATE_FAILURE,
            responseStatus
        }
    },
    ValidateGroupItemTemplateCategory: IGroupItemTemplateCategoryValidateActionCreator = (formData) => {
        return {
            type: ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IGroupItemTemplateCategoryValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IGroupItemTemplateCategoryValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE_FAILURE,
            responseStatus
        }
    },
    Clear: IGroupItemTemplateCategoryClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_GROUPITEMTEMPLATECATEGORY_CLEAR,
            propertiesToClear
        }
    },
    Filter: IGroupItemTemplateCategoryFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_GROUPITEMTEMPLATECATEGORY_FILTER,
            formFilter
        }
    };



export const
    ACTION_GROUPITEMTEMPLATECATEGORY_LOAD = "ACTION_GROUPITEMTEMPLATECATEGORY_LOAD",
    ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_BY_ID = "ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_BY_ID",
    ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_SUCCESS = "ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_SUCCESS",
    ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_FAILURE = "ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_FAILURE",

    ACTION_GROUPITEMTEMPLATECATEGORY_SAVE = "ACTION_GROUPITEMTEMPLATECATEGORY_SAVE",
    ACTION_GROUPITEMTEMPLATECATEGORY_SAVE_SUCCESS = "ACTION_GROUPITEMTEMPLATECATEGORY_SAVE_SUCCESS",
    ACTION_GROUPITEMTEMPLATECATEGORY_SAVE_FAILURE = "ACTION_GROUPITEMTEMPLATECATEGORY_SAVE_FAILURE",

    ACTION_GROUPITEMTEMPLATECATEGORY_CREATE = "ACTION_GROUPITEMTEMPLATECATEGORY_CREATE",
    ACTION_GROUPITEMTEMPLATECATEGORY_CREATE_SUCCESS = "ACTION_GROUPITEMTEMPLATECATEGORY_CREATE_SUCCESS",
    ACTION_GROUPITEMTEMPLATECATEGORY_CREATE_FAILURE = "ACTION_GROUPITEMTEMPLATECATEGORY_CREATE_FAILURE",

    ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE = "ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE",
    ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE_SUCCESS = "ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE_SUCCESS",
    ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE_FAILURE = "ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE_FAILURE",

    ACTION_GROUPITEMTEMPLATECATEGORY_CLEAR = "ACTION_GROUPITEMTEMPLATECATEGORY_CLEAR",

    ACTION_GROUPITEMTEMPLATECATEGORY_FILTER = "ACTION_GROUPITEMTEMPLATECATEGORY_FILTER";

export interface IGroupItemTemplateCategoryLoadAction {
    type: "ACTION_GROUPITEMTEMPLATECATEGORY_LOAD";
}

export interface IGroupItemTemplateCategoryLoadActionCreator {
    (): IGroupItemTemplateCategoryLoadAction;
}

export interface IGroupItemTemplateCategoryLoadSuccessAction {
    type: "ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_SUCCESS";
    formData: Dtos.GroupItemTemplateCategory | Dtos.GroupItemTemplateCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupItemTemplateCategoryLoadSuccessActionCreator {
    (
        formData: Dtos.GroupItemTemplateCategory | Dtos.GroupItemTemplateCategory[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IGroupItemTemplateCategoryLoadSuccessAction;
}

export interface IGroupItemTemplateCategoryLoadFailureAction {
    type: "ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupItemTemplateCategoryLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupItemTemplateCategoryLoadFailureAction;
}

export interface IGroupItemTemplateCategoryLoadByIdAction {
    type: "ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_BY_ID";
    id: number;
}

export interface IGroupItemTemplateCategoryLoadByIdActionCreator {
    (id: number): IGroupItemTemplateCategoryLoadByIdAction;
}


export interface IGroupItemTemplateCategorySaveAction {
    type: "ACTION_GROUPITEMTEMPLATECATEGORY_SAVE";
    formData: Dtos.GroupItemTemplateCategory;

}

export interface IGroupItemTemplateCategorySaveActionCreator {
    (
        formData: Dtos.GroupItemTemplateCategory
    ): IGroupItemTemplateCategorySaveAction;
}

export interface IGroupItemTemplateCategorySaveSuccessAction {
    type: "ACTION_GROUPITEMTEMPLATECATEGORY_SAVE_SUCCESS";
    formData: Dtos.GroupItemTemplateCategory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupItemTemplateCategorySaveSuccessActionCreator {
    (
        formData: Dtos.GroupItemTemplateCategory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IGroupItemTemplateCategorySaveSuccessAction;
}

export interface IGroupItemTemplateCategorySaveFailureAction {
    type: "ACTION_GROUPITEMTEMPLATECATEGORY_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupItemTemplateCategorySaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupItemTemplateCategorySaveFailureAction;
}

export interface IGroupItemTemplateCategoryCreateAction {
    type: "ACTION_GROUPITEMTEMPLATECATEGORY_CREATE"
}

export interface IGroupItemTemplateCategoryCreateActionCreator {
    (): IGroupItemTemplateCategoryCreateAction
}

export interface IGroupItemTemplateCategoryCreateSuccessAction {
    type: "ACTION_GROUPITEMTEMPLATECATEGORY_CREATE_SUCCESS";
    formData: Dtos.GroupItemTemplateCategory;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IGroupItemTemplateCategoryCreateSuccessActionCreator {
    (
        formData: Dtos.GroupItemTemplateCategory,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IGroupItemTemplateCategoryCreateSuccessAction;
}

export interface IGroupItemTemplateCategoryCreateFailureAction {
    type: "ACTION_GROUPITEMTEMPLATECATEGORY_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupItemTemplateCategoryCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupItemTemplateCategoryCreateFailureAction;
}

export interface IGroupItemTemplateCategoryValidateAction {
    type: "ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE";
    formData: Dtos.GroupItemTemplateCategory;

}

export interface IGroupItemTemplateCategoryValidateActionCreator {
    (
        formData: Dtos.GroupItemTemplateCategory
    ): IGroupItemTemplateCategoryValidateAction;
}

export interface IGroupItemTemplateCategoryValidateSuccessAction {
    type: "ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE_SUCCESS";
    formData: Dtos.GroupItemTemplateCategory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupItemTemplateCategoryValidateSuccessActionCreator {
    (
        formData: Dtos.GroupItemTemplateCategory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IGroupItemTemplateCategoryValidateSuccessAction;
}

export interface IGroupItemTemplateCategoryValidateFailureAction {
    type: "ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupItemTemplateCategoryValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupItemTemplateCategoryValidateFailureAction;
}

export interface IGroupItemTemplateCategoryClearAction {
    type: "ACTION_GROUPITEMTEMPLATECATEGORY_CLEAR";
    propertiesToClear?: string[];
}

export interface IGroupItemTemplateCategoryClearActionCreator {
    (propertiesToClear?: string[]): IGroupItemTemplateCategoryClearAction;
}

export interface IGroupItemTemplateCategoryFilterActionCreator {
    (formFilter: IFormFilter): IGroupItemTemplateCategoryFilterAction;
}

export interface IGroupItemTemplateCategoryFilterAction {
    type: "ACTION_GROUPITEMTEMPLATECATEGORY_FILTER";
    formFilter: IFormFilter;
}

export type GroupItemTemplateCategoryAction =
    IGroupItemTemplateCategoryLoadAction |
    IGroupItemTemplateCategoryLoadByIdAction |
    IGroupItemTemplateCategoryLoadFailureAction |
    IGroupItemTemplateCategoryLoadSuccessAction |
    IGroupItemTemplateCategorySaveAction |
    IGroupItemTemplateCategorySaveSuccessAction |
    IGroupItemTemplateCategorySaveFailureAction |
    IGroupItemTemplateCategoryCreateAction |
    IGroupItemTemplateCategoryCreateSuccessAction |
    IGroupItemTemplateCategoryCreateFailureAction |
    IGroupItemTemplateCategoryValidateAction |
    IGroupItemTemplateCategoryValidateSuccessAction |
    IGroupItemTemplateCategoryValidateFailureAction |
    IGroupItemTemplateCategoryClearAction |
    IGroupItemTemplateCategoryFilterAction;
